import { TemplateRef } from "@angular/core";
import { FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material';
import * as moment from 'moment';
var Reso_modComponent = /** @class */ (function () {
    function Reso_modComponent(dialog) {
        this.dialog = dialog;
        this.rows = [];
        this.matcher = new FormService();
        this.numeroForms = 0;
        this.totalsup = 0;
        this.maxDate = moment().toDate();
        this.form = new FormGroup({
            reso_num: new FormControl(''),
            fecha_reso: new FormControl(''),
        });
        if (!JSON.parse(localStorage.getItem("reso_mod"))) {
            localStorage.setItem("reso_mod", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("reso_mod"));
            this.form.controls['reso_num'].setValue(this.rows[0] ? this.rows[0].reso_num : '');
            this.form.controls['fecha_reso'].setValue(this.rows[0] ? this.rows[0].fecha_reso : '');
        }
        this.reso_mod = { reso_num: '', fecha_reso: '' };
        this.temp_reso_mod = { reso_num: '', fecha_reso: '' };
    }
    Reso_modComponent.prototype.add_reso_mod = function () {
        this.fecha_reso = moment().format('DD/MM/YYYY');
        this.actualRow = localStorage.getItem("reso_mod");
        this.rows = JSON.parse(this.actualRow);
        if (!this.form.value.reso_num) {
            console.log("no se ingresaron datos");
            this.dialog.open(this.openModalNODATA);
        }
        else {
            this.rows = this.rows.concat({
                reso_mod: this.form.value.reso_mod,
                reso_num: this.form.value.reso_num,
                fecha_reso: this.fecha_reso
            });
            localStorage.setItem("reso_mod", JSON.stringify(this.rows));
            this.form.reset();
        }
    };
    Reso_modComponent.prototype.get_reso_mod = function (id) {
        console.log(id);
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.temp_reso_mod.id = id;
                this.temp_reso_mod.reso_mod = this.rows[x].reso_mod;
                this.temp_reso_mod.reso_num = this.rows[x].reso_num;
                this.temp_reso_mod.fecha_reso = this.rows[x].fecha_reso;
                this.dialog.open(this.openModal);
            }
        }
    };
    Reso_modComponent.prototype.cleanData = function () {
        this.temp_reso_mod = { reso_num: "", fecha_reso: "" };
    };
    Reso_modComponent.prototype.save_reso_mod = function () {
        var id = this.temp_reso_mod.id;
        console.log(this.temp_reso_mod);
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("reso_mod", JSON.stringify(this.rows));
                $("#clasif_modal").modal("hide");
                this.actualRow = localStorage.getItem("reso_mod");
                this.rows = JSON.parse(this.actualRow);
                this.rows = this.rows.concat({
                    reso_num: this.temp_reso_mod.reso_num,
                    fecha_reso: this.temp_reso_mod.fecha_reso
                });
                localStorage.setItem("reso_mod", JSON.stringify(this.rows));
                this.temp_reso_mod = { reso_num: "", fecha_reso: "" };
                this.dialog.closeAll();
            }
        }
    };
    Reso_modComponent.prototype.delete_reso_mod = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("reso_mod", JSON.stringify(this.rows));
                this.rows = JSON.parse(localStorage.getItem('reso_mod'));
            }
        }
    };
    return Reso_modComponent;
}());
export { Reso_modComponent };
